import { AppointmentDTO } from "@gymflow/types";
import {
  DotBadge,
  DotBadgeProps,
} from "apps/portal/src/components/atoms/DotBadge";
import { useTranslation } from "react-i18next";

type AppointmentPaymentStatusBadgeProps = {
  appointment: Pick<AppointmentDTO, "paymentStatus">;
};

export const AppointmentPaymentStatusBadge = ({
  appointment,
}: AppointmentPaymentStatusBadgeProps) => {
  const { t } = useTranslation();
  return (
    <DotBadge
      intent={
        (
          {
            PAID: "success",
            UNPAID: "error",
            REFUNDED: "gray",
          } as {
            [key in AppointmentDTO["paymentStatus"]]: DotBadgeProps["intent"];
          }
        )[appointment.paymentStatus]
      }
      size="small"
    >
      {t(`portal.common.appointmentPaymentStatus.${appointment.paymentStatus}`)}
    </DotBadge>
  );
};
